import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Activity, TrendingDown, RefreshCw } from 'lucide-react';
import {
  useAdminData, Metric, LoadingBlock, ErrorBox, SectionNote, count, pct,
} from '../../components/admin/AdminKit';

// WO-36 — each step is shown as a share of signups, so no step can read above
// 100% (the old page showed "Activated → Paid 600%"). "Activated" means the
// person created a first CRM opportunity — the field opportunities really use.

const COLORS = ['bg-blue-500', 'bg-cyan-500', 'bg-green-500', 'bg-emerald-600'];

export default function AdminFunnel() {
  const { data, loading, error, reload } = useAdminData('/api/analytics/funnel/overview');
  if (loading) return <LoadingBlock testid="admin-funnel-loading" />;
  const stages = data?.stages || [];

  return (
    <div className="space-y-6" data-testid="admin-funnel-page">
      <div>
        <h1 className="text-2xl font-bold">Funnel</h1>
        <p className="text-muted-foreground">From signup to paying — customers only</p>
      </div>
      {error && <ErrorBox message={error} onRetry={reload} />}
      {data && (
        <>
          <Card className="border-0 bg-card/50">
            <CardHeader>
              <CardTitle>How far people get</CardTitle>
              <CardDescription>Each bar is a share of everyone who signed up</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              {stages.map((s, i) => (
                <div key={s.key} data-testid={`funnel-${s.key}`}>
                  <div className="flex items-center justify-between text-sm mb-1">
                    <span className="font-medium">{s.label}</span>
                    <span><b>{count(s.count)}</b> <span className="text-muted-foreground">({pct(s.pct_of_signups) ?? '—'})</span></span>
                  </div>
                  <div className="h-6 bg-muted rounded-md overflow-hidden">
                    <div className={`h-full ${COLORS[i % COLORS.length]} rounded-md`} style={{ width: `${s.pct_of_signups || 0}%` }} />
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Metric label="Active, last 30 days" icon={Activity} value={count(data.active_30d)} note="Used the app" />
            <Metric label="Cancelled, last 30 days" icon={TrendingDown} value={count(data.cancellations_30d?.total)} />
            <Metric label="Retention by signup month" icon={RefreshCw} value={null}
              why="Needs a few months of activity history (Phase 3)" />
          </div>
          <SectionNote>
            "Paying" counts people with a live Stripe subscription or a seat in a paid Enterprise. Access granted by an
            admin is not payment.
          </SectionNote>
        </>
      )}
    </div>
  );
}
